import React from 'react';
import { Modal, Button } from 'antd';

export default function EncyclopediaDeleteModal({ open, onCancel, onConfirm, entry, loading }) {
  return (
    <Modal
      title="Delete encyclopedia entry"
      open={!!open}
      onCancel={onCancel}
      footer={[
        <Button
          key="delete"
          danger
          onClick={onConfirm}
          loading={loading}
          className="app-btn-delete"
        >
          Delete
        </Button>,
        <Button key="cancel" onClick={onCancel} className="app-btn-cancel">
          Cancel
        </Button>,
      ]}
      destroyOnClose
    >
      {entry && (
        <>
          Are you sure you want to delete <strong>{entry.name}</strong>?
        </>
      )}
    </Modal>
  );
}
